import React from "react";
// import '../../../assets/CSS/bootstrap-5-48-FBX.css';
import './NavPill.style.scss';

const NavPill = ({ theValue, buttonColor, textColor, onClick,isPillFiltered,isDisabled,theTitle }) => {
    // Conditionally render the component only if theValue > 0
    if (theValue <= 0) {
        return null; // Return nothing if theValue is 0 or less
    }

    return (
        <div
            className="btn btn-sm wide45"
            onClick={onClick} // Attach onClick here
            style={{
                backgroundColor: isPillFiltered ? 'orange' : buttonColor,
                color: textColor || 'white', // Use textColor if provided, otherwise default to white,
                cursor: isDisabled ? "not-allowed" : "pointer",
            }}
            title={theTitle}
        >
            {theValue}
        </div>
    );
};

export default NavPill;
